import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';
import { Button } from '../../Controls/Button/index.js';
import Icons from '../../Elements/Icons/index.js';
import Typography from '../../Typography/index.js';
import { FileActions, FileAttributes, FileName, FileStatusCard } from './FileStatus.styled.js';
export const ExistingFileStatus = ({ file, onRemove }) => {
    const { colors } = useTheme();
    const handleRemove = useCallbackRef(() => {
        onRemove?.(file);
    });
    return (_jsx(FileStatusCard, { "data-testid": 'existing-file-status-card', children: _jsxs(FileAttributes, { children: [_jsx(FileName, { children: _jsx(Typography.TextMedium, { children: file.name }) }), _jsx(FileActions, { children: _jsx(Button, { onClick: handleRemove, ghost: true, children: _jsx(Icons.Delete, { size: 20, color: colors.critical100 }) }) })] }) }));
};
